import { useState, useRef, useEffect } from 'react';
import { I18N, GlobalContext, EBPagination } from 'commons';

const ITEM_PER_PAGE = 10;

const defaultPage = {
    currentPage: 1,
    totalPage: 1
}

const GroupMembershipList = ({ groupMembershipList }) => {
    const [page, setPage] = useState(defaultPage);
    const ref = useRef();
    const total = groupMembershipList?.length;
    const totalPage = Math.ceil(groupMembershipList?.length / ITEM_PER_PAGE);
    const currentList = groupMembershipList?.slice((page.currentPage - 1) * ITEM_PER_PAGE, page.currentPage * ITEM_PER_PAGE);


    useEffect(() => {
        if (groupMembershipList?.length > 0 && page.currentPage === 1 && ref.current?.style) {
            ref.current.style.minHeight = `${ref.current?.clientHeight}px`;
        }
    }, []);


    const updatePagination = (pageNo) => {
        setPage({
            ...page,
            currentPage: pageNo
        });
    }
    return (
        <>
            <ul ref={ref} className="group-membership-list">
                {currentList.map(({ groupId, groupName }) => (
                    <li className="group-membership-list-item" key={groupId}>{groupName}</li>
                ))}
            </ul>
            {
                total > ITEM_PER_PAGE &&
                <EBPagination
                    showTotal={(total, range) => <I18N>{`event.table.pagination.pageInfo,${range[0]},${range[1]}, ${total}`}</I18N>}
                    defaultCurrent={1}
                    total={groupMembershipList?.length}
                    onChange={updatePagination}
                    pageSize={10}
                    current={page.currentPage}
                />
            }

        </>
    );
}

export default GroupMembershipList;